import DataTable from "react-data-table-component";

const NotificationPopup = (props) => {
    const { userList, loading, error } = props;
    const columns = [
        {
            name: 'SR.No',
            selector: (row) => (
                <div>
                    <input type="checkbox" />
                </div>
            ),
            sortable: false,
            width: '80px',
        },
        {
            name: 'Name',
            selector: row => row.Name,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Email Id',
            selector: row => (
                <div className="" >
                    <h6>{row.EmailId}</h6>
                    <span>{row?.MobileNo}</span>
                </div>
            ),
            sortable: true,
            minWidth: '250px'
        }
    ];

    return (
        <div>
            {error ? (
                <p>Data not avaiable</p>
            ) : (
                <div className="datatable_popup mt-4">
                    <DataTable
                        columns={columns}
                        data={userList || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>
            )}
        </div>
    )
}

export default NotificationPopup;